'use strict';

const FACING = {
	"דרום": {
		"en": "South",
		"ru": "",
		"he": "דרום"
	},
	
	"צפון": {
		"en": "North",
		"ru": "",
		"he": "צפון"
	},
	"מזרח": {
		"en": "East",
		"ru": "",
		"he": "מזרח"
	},
	
	"מערב": {
		"en": "West",
		"ru": "",
		"he": "מער"
	},
	"South": {
		"en": "South"
	},
	"North": {
		"en": "North"
	},
	"East": {
		"en": "East"
	},
	"West": {
		"en": "West"
	}
};


export class Facing {
	static parse(data) {
		const  facing = data.facing.split(/,|-/);
		const unique = [...new Set(facing)];
		unique.forEach((face,index) => {
			unique[index] = FACING[face].en
		});
		data.facing = unique;
		
		const facingInLine = data.facing.join('');
		let order = null;
		
		switch (facingInLine) {
			case 'WestNorth':
			case 'NorthWest':
				order = 0;
				break;
			case 'EastNorth':
			case 'NorthEast':
				order = 2;
				break;
			case 'WestSouth':
			case 'SouthWest':
				order = 6;
				break;
			case 'EastSouth':
			case 'SouthEast':
				order = 4;
				break;
			case 'WestNorthEast':
			case 'NorthWestEast':
			case 'NorthEastWest':
			case 'WestEastNorth':
			case 'EastWestNorth':
			case 'EastNorthWest':
				order = 1;
				break;
			case 'NorthEastSouth':
			case 'NorthSouthEast':
			case 'EastNorthSouth':
			case 'EastSouthNorth':
			case 'SouthEastNorth':
			case 'SouthNorthEast':
				order = 3;
				break;
			case 'SouthWestNorth':
			case 'SouthNorthWest':
			case 'WestSouthNorth':
			case 'WestNorthSouth':
			case 'NorthSouthWest':
			case 'NorthWestSouth':
				order = 7;
				break;
			case 'WestSouthEast':
			case 'WestEastSouth':
			case 'EastSouthWest':
			case 'EastWestSouth':
			case 'SouthEastWest':
			case 'SouthWestEast':
				order = 5;
				break;
			case 'North':
				order = 1;
				break;
			case 'West':
				order = 7;
				break;
			case 'South':
				order = 5;
				break;
			case 'East':
				order = 3;
				break;
			default:
				order = 8;
				break;
		}
		
		data.facingOrder = order;
	}
	
	static startCheckpointT(apt) {
		const facingInLine = apt.facing.join('');
		const half = 1 / 2;
		const quarter = 1 / 4;
		const octet = 1 / 8;
		
		let t = null;
		
		switch (facingInLine) {
			case 'WestNorth':
			case 'NorthWest':
				t = 0;
				break;
			case 'EastNorth':
			case 'NorthEast':
				t = quarter;
				break;
			case 'WestSouth':
			case 'SouthWest':
				t = half + quarter;
				break;
			case 'EastSouth':
			case 'SouthEast':
				t = half;
				break;
			case 'WestNorthEast':
			case 'NorthWestEast':
			case 'NorthEastWest':
			case 'WestEastNorth':
			case 'EastWestNorth':
			case 'EastNorthWest':
				t = octet;
				break;
			case 'NorthEastSouth':
			case 'NorthSouthEast':
			case 'EastNorthSouth':
			case 'EastSouthNorth':
			case 'SouthEastNorth':
			case 'SouthNorthEast':
				t = quarter + octet;
				break;
			case 'SouthWestNorth':
			case 'SouthNorthWest':
			case 'WestSouthNorth':
			case 'WestNorthSouth':
			case 'NorthSouthWest':
			case 'NorthWestSouth':
				t = 1 - octet;
				break;
			case 'WestSouthEast':
			case 'WestEastSouth':
			case 'EastSouthWest':
			case 'EastWestSouth':
			case 'SouthEastWest':
			case 'SouthWestEast':
				t = half + octet;
				break;
			case 'North':
				t = octet;
				break;
			case 'West':
				t = 1 - octet;
				break;
			case 'South':
				t = half + octet;
				break;
			case 'East':
				t = quarter + octet;
				break;
			default:
				t = 0;
				break;
		}
		
		return t;
	}
	
	static sort(apartments) {
		apartments.sort((a,b) => a.facingOrder - b.facingOrder);
	}
	
}
